module.exports = __webpack_public_path__ + "img/SSS-M-18.68328faa.svg";